export enum ReferralSourceEnum {
  INTERNAL_REFERRAL = "Internal Referral",
}
